import { theme } from 'antd'
import { observer } from 'mobx-react-lite'

import { DashboardStatTile, StatGrid } from '@/Ship/Components/Dashboard/DashboardStatTile'
import { Panel } from '@/Ship/Components/Dashboard/Overview/shared'
import { dashboardManager } from '@/Ship/Stores/DashboardManager'

import type { IActivityDashboard } from '@/Ship/Contracts/IActivityDashboard'

type TileKey = keyof Pick<IActivityDashboard, 'today' | 'week' | 'overdue'>

/** Підписи — «Справи», а не «Завдання» легасі (`SPEC-002` §2.5). */
export const ACTIVITY_TILES: ReadonlyArray<{ key: TileKey; title: string }> = [
    { key: 'today', title: 'Справи на сьогодні' },
    { key: 'week', title: 'Справи на поточний тиждень' },
    { key: 'overdue', title: 'Протерміновані справи' },
]

/** Стан помилки: число невідоме — прочерк, а не старе значення (Н-3). */
export const UNKNOWN_VALUE = '—'

/**
 * Блок «Справи» (`SPEC-015` §5.3): три числа в одному блоці.
 *
 *  - «Протерміновані справи» червоні **лише коли > 0** (ВП-4): червоний нуль
 *    читається як тривога. Колір — токеном теми, тож темна тема його бачить;
 *  - клік нічого не робить (ВП-3) — числа не є посиланнями;
 *  - числа — усієї компанії (адміністратор без фільтра), обраного
 *    співробітника або свої; підзаголовок каже, чиї.
 */
export const ActivityTiles = observer(() => {
    const { token } = theme.useToken()
    const { activity, isLoading } = dashboardManager

    return (
        <Panel block="activities" title="Справи" subtitle={dashboardManager.activitiesScopeLabel}>
            <StatGrid columns={3}>
                {ACTIVITY_TILES.map((tile) => {
                    const value = activity?.[tile.key]
                    const danger = tile.key === 'overdue' && typeof value === 'number' && value > 0

                    return (
                        <DashboardStatTile
                            key={tile.key}
                            tile={tile.key}
                            title={tile.title}
                            value={value ?? UNKNOWN_VALUE}
                            loading={isLoading}
                            {...(danger ? { color: token.colorError } : {})}
                        />
                    )
                })}
            </StatGrid>
        </Panel>
    )
})
